__turbopack_context__.v({
  "cardTitle": "ErwY6W_cardTitle",
  "cta": "ErwY6W_cta",
  "ctaTitle": "ErwY6W_ctaTitle",
  "displayText": "ErwY6W_displayText",
  "gradient-move": "ErwY6W_gradient-move",
  "gradientText": "ErwY6W_gradientText",
  "hero": "ErwY6W_hero",
  "heroCtaLink": "ErwY6W_heroCtaLink",
  "heroCtas": "ErwY6W_heroCtas",
  "heroGradient": "ErwY6W_heroGradient",
  "heroHighlights": "ErwY6W_heroHighlights",
  "heroHighlightsGrid": "ErwY6W_heroHighlightsGrid",
  "heroSubtext": "ErwY6W_heroSubtext",
  "heroTitle": "ErwY6W_heroTitle",
  "heroTitleWrapper": "ErwY6W_heroTitleWrapper",
  "home": "ErwY6W_home",
  "lead": "ErwY6W_lead",
  "sectionAccentCyan": "ErwY6W_sectionAccentCyan",
  "sectionAccentPink": "ErwY6W_sectionAccentPink",
  "sectionAccentPurple": "ErwY6W_sectionAccentPurple",
  "sectionAccentTeal": "ErwY6W_sectionAccentTeal",
  "sectionAccentViolet": "ErwY6W_sectionAccentViolet",
  "sectionAccentYellow": "ErwY6W_sectionAccentYellow",
  "sectionTitle": "ErwY6W_sectionTitle",
  "selectedClientsDivider": "ErwY6W_selectedClientsDivider",
  "selectedClientsLabel": "ErwY6W_selectedClientsLabel",
  "selectedClientsPanel": "ErwY6W_selectedClientsPanel",
  "workImage": "ErwY6W_workImage",
  "workItem": "ErwY6W_workItem",
});
